import { render, staticRenderFns } from "./fail2.vue?vue&type=template&id=3c22b922&scoped=true"
import script from "./fail2.vue?vue&type=script&lang=js"
export * from "./fail2.vue?vue&type=script&lang=js"
import style0 from "./fail2.vue?vue&type=style&index=0&id=3c22b922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22b922",
  null
  
)

export default component.exports